import { render, staticRenderFns } from "./mdbCalendar.vue?vue&type=template&id=9bccf650&scoped=true&"
import script from "./mdbCalendar.vue?vue&type=script&lang=js&"
export * from "./mdbCalendar.vue?vue&type=script&lang=js&"
import style0 from "./mdbCalendar.vue?vue&type=style&index=0&id=9bccf650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bccf650",
  null
  
)

export default component.exports